import api from "./Api";

class UsuarioTelefoneService {
  GetUsuarioTelefone(payload) {
    return api.get("/v1/usuariotelefone/" + payload).then((response) => {
      return response.data;
    });
  }

  PostUsuarioTelefone(payload) {
    return api.post("/v1/usuariotelefone/", payload).then((response) => {
      return response.data;
    });
  }

  PutUsuarioTelefone(payload) {
    return api.put("/v1/usuariotelefone/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteUsuarioTelefone(payload) {
    return api.delete("/v1/usuariotelefone/" + payload).then((response) => {
      return response.data;
    });
  }

  GetUsuarioTelefoneOData(payload) {
    return api.get("/OData/usuariotelefone" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new UsuarioTelefoneService();
